import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext, useField } from 'formik'
import Checkbox from '@material-ui/core/Checkbox'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import { PRESERVE_INSTRUCTORS_CHECK_FIELDS } from '../formDefinitions'

const useStyles = (vstTheme) =>
  makeStyles(() => ({
    root: {
      paddingLeft: 0,
      '&.Mui-checked': {
        color: `${vstTheme?.vstui?.color?.primary.getShade(6)} !important`,
      },
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
    label: {
      display: 'flex',
      alignItems: 'center',
    },
  }))()

const PreserveInstructorsCheckField = ({ theme, ...props }) => {
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext()
  const classes = useStyles(theme)
  const [field] = useField(props)

  const handleChange = (event) => {
    setFieldValue(PRESERVE_INSTRUCTORS_CHECK_FIELDS.name, event.target.checked)
  }

  return (
    <div className="form-module preserve-instructors-check">
      <Checkbox
        id={PRESERVE_INSTRUCTORS_CHECK_FIELDS.name}
        checked={field.value}
        onChange={handleChange}
        inputProps={{ 'aria-label': t(PRESERVE_INSTRUCTORS_CHECK_FIELDS.i18n) }}
        className={classes.root}
        disableRipple={true}
        disabled={props.disabled}
      />
      <div className={classes.label}>
        <span>{t(PRESERVE_INSTRUCTORS_CHECK_FIELDS.i18n)}</span>
      </div>
    </div>
  )
}

export default memo(PreserveInstructorsCheckField)

PreserveInstructorsCheckField.propTypes = {
  /**
   * Theme object
   */
  theme: PropTypes.shape({}),
  name: PropTypes.string,
  disabled: PropTypes.bool,
}

PreserveInstructorsCheckField.defaultProps = {
  theme: {},
  name: PRESERVE_INSTRUCTORS_CHECK_FIELDS.name,
  disabled: false,
}
